<template>
  <div class="mt-1 d-flex align-center justify-end flex-nowrap">
    <v-btn
      v-if="showDashboard"
      class="me-2"
      small
      color="primary"
      height="25"
      style="border-radius: 5px; font-size: 11px; text-transform: none; flex-shrink: 0;"
      @click="$emit('go-dashboard')"
    >
      {{ $t('dashboard') }}
    </v-btn>
    <v-scroll-y-transition
      v-for="(action, i) in actions"
      :key="i"
    >
      <v-tooltip
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="me-2"
            elevation="2"
            v-bind="attrs"
            fab
            tile
            dark
            x-small
            style="border-radius: 5px;width: 25px;height: 25px"
            :color="action.color"
            v-on="on"
            @click="open(action)"
          >
            <v-icon dark>
              {{ action.icon }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t(action.title) }}</span>
      </v-tooltip>
    </v-scroll-y-transition>
    <v-tooltip
      bottom
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="me-2"
          elevation="2"
          v-bind="attrs"
          fab
          tile
          dark
          x-small
          style="border-radius: 5px;width: 25px;height: 25px"
          color="orange"
          v-on="on"
          @click="openTask"
        >
          <v-icon dark>
            mdi-checkbox-marked-circle-plus-outline
          </v-icon>
        </v-btn>
      </template>
      <span>{{ $t('task') }}</span>
    </v-tooltip>
    <v-tooltip
      bottom
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-show="account && account.mobile"
          class="me-2"
          elevation="2"
          v-bind="attrs"
          fab
          tile
          dark
          x-small
          style="border-radius: 5px;width: 25px;height: 25px"
          color="green"
          v-on="on"
          @click="remainAccountSms(account)"
        >
          <v-icon dark>
            mdi-message-text-outline
          </v-icon>
        </v-btn>
      </template>
      <span>{{ $t('remainAccountSMS') }}</span>
    </v-tooltip>
    <v-tooltip
      bottom
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-show="account && account.mobile"
          class="me-2"
          elevation="2"
          v-bind="attrs"
          fab
          tile
          dark
          x-small
          style="border-radius: 5px;width: 25px;height: 25px"
          color="teal"
          v-on="on"
          @click="whatsapp(account.mobile)"
        >
          <v-icon dark>
            mdi-whatsapp
          </v-icon>
        </v-btn>
      </template>
      <span>{{ $t('whatsappMessage') }}</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-show="account"
          v-shortkey="['f5']"
          v-bind="attrs"
          fab
          tile
          x-small
          style="border-radius: 5px;width: 25px;height: 25px"
          color="blue"
          class="float-left"
          @shortkey="$emit('refresh', account.id)"
          v-on="on"
          @click="$emit('refresh', account.id)"
        >
          <v-icon dark>
            mdi-refresh
          </v-icon>
        </v-btn>
      </template>
      <span>{{ $t('refresh') }}(f5)</span>
    </v-tooltip>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = false"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  export default {
    name: 'AutocompleteButton',
    components: {
    },
    props: {
      account: {
        default: null
      },
      showDashboard: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      actions: [
        {
          link: 'turnover',
          title: 'turnover',
          icon: 'mdi-chart-box-outline',
          color: 'primary',
        },
        {
          link: 'purchase',
          title: 'buy',
          icon: 'mdi-shopping-outline',
          color: 'primary',
        },
        {
          link: 'sell',
          title: 'sell',
          icon: 'mdi-sale',
          color: 'primary',
        },
        {
          link: 'presale',
          title: 'presale',
          icon: 'mdi-point-of-sale',
          color: 'primary',
        },
        {
          link: 'recieve',
          title: 'recieve',
          icon: 'mdi-cash-register',
          color: 'primary',
        },
        {
          link: 'pay',
          title: 'pay',
          icon: 'mdi-credit-card-outline',
          color: 'primary',
        },
        {
          link: 'recieveCheck',
          title: 'recieveCheck',
          icon: 'mdi-account-cash-outline',
          color: 'primary',
        },
        {
          link: 'payCheck',
          title: 'payCheck',
          icon: 'mdi-cash-refund',
          color: 'primary',
        },
      ],
      snakbar: false,
      snakbarText: null,
      snakbarColor: 'blue',
    }),
    methods: {
      open (item) {
        this.$router.push({ name: item.link, params: { accountProp: this.account } })
      },
      whatsapp (phone) {
        // window.location.href = res.action
        window.open('https://api.whatsapp.com/send/?phone=98' + phone.substring(1) + '&text=' + this.$t('hello') + '&app_absent=0', '_blank')
      },
      openTask () {
        this.$router.push({ name: 'task', params: { refItem: this.account, refType: 'account' } })
      },
    },
  }
</script>

<style scoped>

</style>
